import { call, put, select } from "redux-saga/effects";
import { Creators as BankAccountFarm } from "../ducks/bankAccountFarm";

/** Services */
import {
  indexAllDropdownBankAccountFarm,
  indexAllBankAccountFarm,
  saveOrUpdateBankAccountFarm,
} from "../../services/bankAccountFarmService";
import { notification } from "antd";

export const getTranslation = (state) => state.app.translation;

export function* indexBankAccountFarm(action) {
  try {
    const {
      data: { results: paymentMethods },
    } = yield call(indexAllBankAccountFarm, action.payload);
    yield put(BankAccountFarm.getBankAccountFarmSuccess(paymentMethods));
  } catch (error) {
    yield put(BankAccountFarm.getBankAccountFarmError(error));
  }
}

export function* indexDropdownBankAccountFarm(action) {
  try {
    const {
      data: { results: paymentMethods },
    } = yield call(indexAllDropdownBankAccountFarm, action.payload);
    yield put(
      BankAccountFarm.getDropdownBankAccountFarmSuccess(paymentMethods)
    );
  } catch (error) {
    yield put(BankAccountFarm.getDropdownBankAccountFarmError(error));
  }
}

export function* saveBankAccountFarm(action) {
  const translation = yield select(getTranslation);
  try {
    yield call(saveOrUpdateBankAccountFarm, action.payload);
    yield put(BankAccountFarm.saveBankAccountFarmSuccess());
    yield put(
      BankAccountFarm.getBankAccountFarm(
        action.payload.groupId,
        action.payload.farmId
      )
    );
    notification.success({
      message: translation.bankAccountFarm.messages.successMessage,
    });
  } catch (error) {
    yield put(BankAccountFarm.saveBankAccountFarmError(error));
    notification.error({
      message: translation.bankAccountFarm.messages.errorMessage,
    });
  }
}
